import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import styles from './MarkdownText.module.css';

const MarkdownText = React.memo(({ text = '' }) => {
  const combinedRegex = /(\*\*[^*]+\*\*)|(\*[^*]+\*)|(__[^_]+__)|(~~[^~]+~~)/g;

  const formatted = useMemo(() => {
    const elements = [];
    let lastIndex = 0;
    let match;
    let index = 0;

    while ((match = combinedRegex.exec(text)) !== null) {
      if (match.index > lastIndex) {
        elements.push(
          <React.Fragment key={index++}>
            {text.slice(lastIndex, match.index)}
          </React.Fragment>
        );
      }

      const raw = match[0];
      let content, className;

      if (raw.startsWith('**')) {
        content = raw.slice(2, -2);
        className = 'markdown-bold';
      } else if (raw.startsWith('*')) {
        content = raw.slice(1, -1);
        className = 'markdown-italic';
      } else if (raw.startsWith('__')) {
        content = raw.slice(2, -2);
        className = 'markdown-underline';
      } else if (raw.startsWith('~~')) {
        content = raw.slice(2, -2);
        className = 'markdown-strike';
      }

      elements.push(
        <span key={index++} className={styles[className]}>
          {content}
        </span>
      );

      lastIndex = combinedRegex.lastIndex;
    }

    if (lastIndex < text.length) {
      elements.push(
        <React.Fragment key={index++}>{text.slice(lastIndex)}</React.Fragment>
      );
    }

    return elements;
  }, [text]);

  return <>{formatted}</>;
});

MarkdownText.displayName = 'MarkdownText';

export default MarkdownText;

MarkdownText.propTypes = {
  text: PropTypes.string
};
